import React,{useEffect} from 'react'
import MainFeedNavBar from "../MainFeed/MainFeedNavBar.jsx"
import { useNavigate } from 'react-router-dom'
import AgregarEmpresa from '../../Components/Empresa/AddEmpresa.jsx'
const AgregarEmpresaPage= () => {
    const navigate=useNavigate();
    
    
  return (
   <MainFeedNavBar>
        <AgregarEmpresa/>
   </MainFeedNavBar>
  )
}

export default AgregarEmpresaPage
